import type { ModalProps as AntModalProps } from 'antd';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';

import { Close } from '@assets/icons';

type ModalProps = AntModalProps & {
  closeIconColor?: string;
};

const Modal = (props: ModalProps): JSX.Element => {
  return (
    <StyledModal
      open={true}
      destroyOnClose
      closeIcon={<StyledCloseIcon stroke={props.closeIconColor} />}
      {...props}
    />
  );
};

const StyledModal = styled(AntModal)`
  max-height: 85vh;
  height: 100%;
  top: 42px;

  .ant-modal-header {
    border-bottom: 1px solid ${({ theme }) => theme.palette.greyscale[3]};
    margin-bottom: 0;
    padding: 16px 24px;
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    border-radius: 4px;
    box-shadow: 1px 1px 7px 1px rgba(64, 64, 64, 0.25);
    padding: 0;

    .ant-modal-close:hover {
      background-color: unset;
    }
  }

  .ant-modal-body {
    overflow: scroll;
    overflow-y: auto;
    overflow-x: auto;
    max-height: 85vh;
    padding: 16px 24px;
    height: 100%;
    font-size: ${(props) => props.theme.palette.textFontSize[7]};
  }

  .ant-modal-footer {
    border-top: 1px solid ${(props) => props.theme.palette.greyscale[3]};
    padding: 16px 24px;
    margin-top: 0; // this will allow content body to go up to the footer

    display: flex;
    justify-content: flex-end;
  }
`;

const StyledCloseIcon = styled(Close)`
  &:hover {
    path {
      stroke: ${({ theme }) => theme.palette.greyscale[7]};
    }
  }

  path {
    transition: stroke 0.2s;
  }
`;

export { Modal };
